import { CancelOutlined } from '@mui/icons-material';
import { Box, Button, Dialog, IconButton, TextField, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { red } from '@mui/material/colors';
import { useEffect, useState } from 'react';
function ConfirmationDialog2({ open, onClose, message, action, action2, warning, singleButton, Input, deleteBox, overwrite, existingValue }) {
  const [write, setWrite] = useState(false)
  console.log(overwrite);

  const [inputValue, setInputValue] = useState(existingValue);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleActionClick = () => {
    action(inputValue); // Pass the input value to the action function
  };
  const handleActionClick2 = () => {
    action2(inputValue); // Pass the input value to the action function
  };
  useEffect(() => {
    setInputValue('')

    if (localStorage.getItem('saveDesign')) {
      setWrite(true)
    }
    else {
      setWrite(false)
    }
  }, [open])

  return (
    <Dialog
      open={open}
      sx={{
        '& .MuiDialog-paper': {
          width: warning ? { lg: '50%', md: '70%', sm: '80%', xs: '80%' } : { lg: '30%', md: '70%', sm: '80%', xs: '80%' },
          height: "auto",
          borderRadius: 2,
          py: { xs: 2, md: 4 },
          px: { xs: 3, md: 6 },
          backgroundColor: '#0F172A'
        },

      }}
    >
      <IconButton onClick={onClose} sx={{ position: 'absolute', right: 13, top: 13 }}>
        <CancelOutlined sx={{ color: 'white' }} />
      </IconButton>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        {warning && <WarningIcon sx={{ color: red[500], fontSize: '50px !important' }} />}
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography className='heading-font2' variant="h6" sx={{ color: 'white', mt: 1, mb: 1.5 }}>
          {message}
        </Typography>
        {Input != false && !deleteBox && <TextField
          fullWidth
          size="small"
          variant="outlined"
          placeholder="Enter Design Name"
          value={inputValue}
          onChange={handleInputChange}
          sx={{
            mt: 2,
            mb: 2,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'white', // Border color
              },
              '&:hover fieldset': {
                borderColor: 'white', // Border color on hover
              },
              '&.Mui-focused fieldset': {
                borderColor: 'white', // Border color when focused
              },
              color: 'white', // Text color
            },
            '& .MuiInputBase-input': {
              color: 'white', // Text color for input text
            },
            '& .MuiInputLabel-root': {
              color: 'white', // Placeholder color
            },
          }}
          InputProps={{
            style: {
              color: 'white', // Input text color
            },
          }}
        />}

        <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
          {write && <Button
            title={deleteBox ? "Yes" : write ? 'Save and Overwrite' : 'Save'}
            onClick={handleActionClick}
            style={{ backgroundColor: '#0cbadd', color: "#0F172A", textTransform: 'capitalize' }}
          >
            {deleteBox ? "Yes" : 'Save and Overwrite'}
          </Button>}
          {!singleButton ? <Box sx={{ display: 'flex', gap: 2 }}>

            <Button
              disabled={!inputValue}
              title={deleteBox ? "Yes" : overwrite ? 'Save As' : 'Save'}
              onClick={handleActionClick2}
              style={{ backgroundColor: '#0cbadd', color: "#0F172A", textTransform: 'capitalize' }}
            >
              {deleteBox ? "Yes" : overwrite ? 'Save As' : 'Save'}
            </Button>


            <Button
              title="Cancel"
              onClick={onClose}
              style={{ backgroundColor: '#0cbadd', color: "#0F172A", textTransform: 'capitalize' }}
            >
              Cancel
            </Button> </Box> :
            <Button
              title="Continue"
              onClick={handleActionClick}
              style={{ backgroundColor: '#0cbadd', color: "#0F172A", textTransform: 'capitalize' }}
            >
              Continue
            </Button>}
        </Box>
      </Box>
    </Dialog>
  )
}

export default ConfirmationDialog2